import { LayerProps } from "react-map-gl/maplibre";
import { PointSimpleConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getPointSimpleStyles = ({
	symbolStyle,
}: PointSimpleConfigs): LayerProps[] => {
	const styles: LayerProps[] = [];

	if (symbolStyle?.isGraphic !== true) {
		if (symbolStyle?.basic?.symbol === "circle") {
			styles.push({
				id: "fill-stroke-circle",
				type: "circle",
				paint: {
					"circle-color": symbolStyle?.fill?.color ?? "#000000",
					"circle-radius": symbolStyle?.basic?.size ?? 8,
					"circle-opacity": symbolStyle?.fill?.opacity ?? 1,
					"circle-stroke-color": symbolStyle?.stroke?.color ?? "#000000",
					"circle-stroke-width": symbolStyle?.stroke?.width ?? 1,
					"circle-stroke-opacity": symbolStyle?.stroke?.opacity ?? 1,
				},
			});
		} else {
			styles.push({
				type: "symbol",
				layout: {
					"icon-overlap": "always",
					"icon-image": `${symbolStyle?.basic?.symbol}-icon`,
					"icon-size": (symbolStyle?.basic?.size ?? 0) / 15,
					"icon-rotate": symbolStyle?.basic?.rotation ?? 0,
				},
				paint: {
					"icon-color": symbolStyle?.fill?.color ?? "#000000",
					"icon-opacity": symbolStyle?.fill?.opacity ?? 1,
				},
			});
		}
	} else {
		styles.push({
			type: "symbol",
			layout: {
				"icon-overlap": "always",
				"icon-image": `${symbolStyle.name}.png`,
				"icon-size": (symbolStyle?.basic?.size ?? 0) / 15,
				"icon-rotate": symbolStyle?.basic?.rotation ?? 0,
			},
			paint: {
				"icon-color": symbolStyle?.fill?.color ?? "#000000",
				"icon-opacity": symbolStyle?.fill?.opacity ?? 1,
			},
		});
	}
	return styles;
};
